module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "contact-images",
    class: {
      expanded: _vm.contacts.length > 7
    }
  }, [_c('ImageFader', {
    staticClass: "contact-image white-border shadow ",
    style: (_vm.contactOneStyle),
    attrs: {
      "src": _vm.imageOne,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "contact-image white-border shadow ",
    style: (_vm.contactTwoStyle),
    attrs: {
      "src": _vm.imageTwo,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "contact-image white-border shadow ",
    style: (_vm.contactThreeStyle),
    attrs: {
      "src": _vm.imageThree,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-label contact-label-1 ",
    class: {
      visible: this.contacts.length == 2
    }
  }, [_vm._v("\n        " + _vm._s(_vm.contactLabel(_vm.contacts[0])) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "contact-label contact-label-2",
    class: {
      visible: this.contacts.length == 2
    }
  }, [_vm._v("\n        " + _vm._s(_vm.contactLabel(_vm.contacts[1])) + "\n    ")]), _vm._v(" "), _c('v-icon', {
    staticClass: "contact-heart",
    class: {
      hidden: !_vm.partners
    },
    attrs: {
      "color": "red lighten-2"
    }
  }, [_vm._v("\n        mdi-heart\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "group-label",
    class: {
      hidden: _vm.contacts.length < 3, lowered: _vm.contacts.length > 7
    },
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.selectedNames) + " (" + _vm._s(_vm.contacts.length) + ")")]), _vm._v(" "), (_vm.contacts.length > 3) ? _c('div', {
    staticStyle: {
      "padding-left": "11px",
      "padding-top": "2px"
    }
  }, [_c('ImageGroup', {
    attrs: {
      "images": _vm.limitedContacts.map(function (o) { return o.image; })
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2233fae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ContactImages.vue
// module id = 2647
// module chunks = 1